import './OrganizationsList.scss';
import '../../Admin.scss';
import '../../../../styles/_table.scss';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import { useEffect, useMemo } from 'react';

import { DefaultRoutes } from 'Routes';
import HeaderCreateButton from 'components/Admin/HeaderCreateButton/HeaderCreateButton';
import HeaderSearchbar from 'components/Admin/HeaderSearchbar/HeaderSearchbar';
import { Link } from 'react-router-dom';
import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';

type RowsDisplay = {
  id: string;
  name: string;
  disabled: boolean;
};

export const OrganizationsList = observer(() => {
  useSetPageTitle({ title: 'Organizations List', subtitle: '' });
  const os = useStores().organizationsEditorStore;

  useEffect(() => {
    os.organizationsList.length === 0 && os.getOrganizations();
  }, [os]);

  useEffect(() => {
    os.filteredList = os.organizationsList.filter((org) => org.name.toLowerCase().includes(os.searchValue.toLowerCase()));
  }, [os, os.searchValue]);

  const rowsDisplay: RowsDisplay[] = useMemo(
    () =>
      os.filteredList.map((org) => {
        return {
          id: org.id,
          name: org.name,
          disabled: org.disabled,
        };
      }) as RowsDisplay[],
    [os.filteredList]
  );

  return (
    <div className='admin-content-container'>
      <div className='admin-list-header'>
        <HeaderSearchbar searchValue={os.searchValue} onChange={os.setSearchValue} />
        <HeaderCreateButton buttonTitle='New organization' route={DefaultRoutes.OrganizationsEditor} />
      </div>

      <div className='tmu-table-wrapper'>
        <Table sx={{ minWidth: 750 }} className='tmu-table admin-table'>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsDisplay.length ? (
              rowsDisplay.map((row) => {
                return (
                  <TableRow hover tabIndex={-1} key={row.id} className='organization-list-row'>
                    <TableCell>
                      <Link to={`${DefaultRoutes.Admin}/${DefaultRoutes.OrganizationsEditor}/${row.id}`}>{row.name.toLowerCase()}</Link>
                    </TableCell>
                    {row.disabled ? (
                      <TableCell>
                        <span className='disabled-info'>Disabled</span>
                      </TableCell>
                    ) : (
                      <TableCell>Active</TableCell>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell>
                  <Paragraph>
                    <>No organizations found</>
                  </Paragraph>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

export default OrganizationsList;
